import React from 'react';
import PropTypes from 'prop-types';
import { Heading, Image, Button } from '../elements';
import WistiaVideoPlayer from '../../../../components/common/media/WistiaVideoPlayer';

export const MainBannerComponent = (props) => {
    const { backgroundImageDs, backgroundImageMb, backgroundColor, logo, size, tagline, title, video, videoOrLogo, button, url } = props.content;

    let bannerSizeClass = "";
    switch (size) {
        case 'Large':
            bannerSizeClass = 'kiwi-main-banner--large';
            break;
        case 'Medium':
            bannerSizeClass = 'kiwi-main-banner--medium';
            break;
        case 'Small':
            bannerSizeClass = 'kiwi-main-banner--small';
            break;
        default:
            bannerSizeClass = "kiwi-main-banner--medium";
    }

    let bannerLarge = "";
    if (size === 'Large') {
        bannerLarge = 'text-center';
    } else {
        bannerLarge = null;
    }


    let mediaClass = "";
    if (logo) {
        mediaClass = 'display--logo';
    } else {
        mediaClass = 'display--video';
    }

    const style = {
        backgroundColor: `${backgroundColor}`
    };

    const backgroundImageDesktop = {
        backgroundImage: `${backgroundImageDs}`,
    }

    const backgroundImageMobile = {
        backgroundImage: `${backgroundImageMb}`,
    }

    const videoUrl = `https://fast.wistia.net/embed/iframe/${props.content.video}?videoFoam=true`;

    return (
        <section className={`col-12 kiwi-main-banner ${bannerSizeClass} ${mediaClass}`} style={style}>
            <picture className="page-image">
                {backgroundImageMb &&
                    <source className="kiwi-background-image" media="(max-width: 768px)" srcSet={backgroundImageMobile.backgroundImage} />
                }
                <source className="kiwi-background-image" media="(min-width: 769px)" srcSet={backgroundImageDesktop.backgroundImage} />
                <img className="kiwi-background-image" src={backgroundImageDesktop.backgroundImage} alt="" />
            </picture>
            <div className={`mask ${bannerLarge}`}>
                <div className="kiwi-custom-position">
                    <div className="container">
                        <div className="row">
                            <div className="col-xs-12">
                                {logo &&
                                    <div className="kiwi-main-banner__logo">
                                        <Image logo={logo} />
                                    </div>}
                                {video &&
                                    <div className="kiwi-main-banner__video">
                                        <WistiaVideoPlayer url={videoUrl} />
                                    </div>
                                }
                                <div className="kiwi-main-banner__copy">

                                    {title &&
                                        <Heading content={title} size="h1" />}

                                    {tagline &&
                                        <Heading content={tagline} size="h2" />}

                                    {button.label &&
                                        <Button label={button.label} link={button.link} color={button.color} textColor={button.textColor} />}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
};

MainBannerComponent.propTypes = {
    content: PropTypes.object
};




// WEBPACK FOOTER //
// src/client/components/common/CMS/components/MainBannerComponent.js